"use client"

import { Education } from "@/datas/db/prisma"
import { cn } from "@/services/utils/cn"
import { periodDateOptions } from "@/services/utils/date"
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/views/components/_shadcn-ui/avatar"
import { Card, CardHeader } from "@/views/components/_shadcn-ui/card"
import { ChevronRightIcon } from "lucide-react"
import React, { useMemo } from "react"

type EducationCardProps = Education

const EducationCard: React.FC<EducationCardProps> = ({
  school_name,
  degree,
  school_photo,
  gpa,
  from_date,
  to_date,
}) => {
  const period = useMemo(
    () =>
      `${new Date(from_date).toLocaleDateString("en-US", periodDateOptions)} - ${to_date ? new Date(to_date).toLocaleDateString("en-US", periodDateOptions) : "Present"}`,
    [from_date, to_date],
  )

  return (
    <Card className="flex">
      <div className="flex-none">
        <Avatar className="border size-12 m-auto bg-muted-background dark:bg-foreground">
          <AvatarImage
            src={school_photo || ""}
            alt={school_name}
            className="object-contain"
          />
          <AvatarFallback>{school_name[0]}</AvatarFallback>
        </Avatar>
      </div>
      <div className="flex-grow ml-4 items-center flex-col group">
        <CardHeader>
          <div className="flex items-center justify-between gap-x-2 text-base">
            <h3 className="inline-flex items-center justify-center font-semibold leading-none text-xs sm:text-sm">
              {school_name}

              <ChevronRightIcon
                className={cn(
                  "size-4 translate-x-0 transform opacity-0 transition-all duration-300 ease-out group-hover:translate-x-1 group-hover:opacity-100",
                )}
              />
            </h3>
            <div className="text-xs sm:text-sm tabular-nums text-muted-foreground text-right">
              {period}
            </div>
          </div>
          {degree && <div className="font-sans text-xs">{degree}</div>}
          {gpa && (
            <span className="inline-flex gap-x-1">
              <span className="text-xs">GPA : {gpa}</span>
            </span>
          )}
        </CardHeader>
      </div>
    </Card>
  )
}

export default EducationCard
